// extracted by mini-css-extract-plugin
export default {"-large":"cost-tag-module__-large--lhBhs","container":"cost-tag-module__container--pwRWw","pricingText":"cost-tag-module__pricingText--z_dH0"};